import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQuery } from "@tanstack/react-query";

export const useGetReportByDate = (date: string) => {

    const axios = useAxios();
    const {t} = useTranslation();

    const fetchReportByDate = async () => {
        try {
            const { data } = await axios.get(`/api/reports/examInstances/${date}`);
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getReportByDate"));
        }
    }

    return useQuery({queryKey: ["reportByDate", date], queryFn: fetchReportByDate, enabled: date.length > 0 })
}